import React, { FunctionComponent } from 'react';

import styles from './LinkedinPostStatusbar.module.scss';
import { ReactionsIcon } from 'app/assets/images/icons';
import { nFormatter } from 'app/utils/numbersFormater';
import { _t } from 'app/utils/i18n';

interface Props {
  comments_count: number;
  total_reactions: number;
  repost_count: number;
  replies_count?: number;
}

const LinkedinPostStatusbar: FunctionComponent<Props> = ({
  comments_count,
  total_reactions,
  repost_count,
  replies_count,
}) => {
  return (
    <div className={styles.LinkedinPostStatusbar}>
      {total_reactions !== 0 && total_reactions && (
        <div>
          <div>
            <ReactionsIcon />
          </div>

          <span>{nFormatter(total_reactions)}</span>
        </div>
      )}

      {comments_count !== 0 && comments_count && (
        <div>
          <p>{_t('posts:comments')}</p>
          <span>{nFormatter(comments_count)}</span>
        </div>
      )}
      {repost_count !== 0 && repost_count && (
        <div>
          <p>{_t('posts:reposts')}</p>
          <span>{nFormatter(repost_count)}</span>
        </div>
      )}
      {replies_count !== 0 && replies_count && (
        <div>
          <p>{_t('posts:replies')}</p>
          <span>{nFormatter(replies_count)}</span>
        </div>
      )}
    </div>
  );
};

export default LinkedinPostStatusbar;
